import React, { useState, useEffect } from "react";
import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

// Fix for default marker icon
import iconUrl from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";

const defaultIcon = new L.Icon({
  iconUrl,
  shadowUrl: iconShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

const LocationMarker = ({ position, setPosition, onSelect }) => {
  useMapEvents({
    click(e) {
      const coords = [e.latlng.lat, e.latlng.lng];
      setPosition(coords);
      if (onSelect) onSelect({ latitude: coords[0], longitude: coords[1] });
    },
  });

  return position ? <Marker position={position} icon={defaultIcon} /> : null;
};

const OpenMapSelector = ({ initialLat, initialLng, onSelect }) => {
  if(!initialLat) initialLat = 6.63389
  if(!initialLng) initialLng = 124.59797

  const [position, setPosition] = useState([initialLat, initialLng]);

  useEffect(() => {
      setPosition([initialLat, initialLng]);
  }, [initialLat, initialLng]);

  return (
    <div>
      <MapContainer center={position} zoom={13} style={{ height: "400px", width: "100%" }}>
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <LocationMarker position={position} setPosition={setPosition} onSelect={onSelect} />
      </MapContainer>
      {/* <p style={{ marginTop: "10px" }}>
        Selected Coordinates: Latitude {position?.[0].toFixed(5)}, Longitude {position?.[1].toFixed(5)}
      </p> */}
    </div>
  );
};

export default OpenMapSelector;
